import ErrorIcon from '@jbhi-fi/lanyard-ui/components/Icons/Error';
import TickIcon from '@jbhi-fi/lanyard-ui/components/Icons/Tick';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import React from 'react';
import { styles } from './ProductCompareTable.css';
import { Spec } from '@jbhi-fi/apis/src/compare';

const getCellDisplayValue = (value: string) => {
  switch (value.toLowerCase()) {
    case 'true':
    case 'yes':
      return <TickIcon fontSize={20} color={palette.success.main} className={styles.icons} />;
    case 'false':
    case 'no':
      return <ErrorIcon fontSize={20} color={palette.error.main} className={styles.icons} />;
    default:
      return value;
  }
};

interface ProductCompareTableSubSectionProps {
  specs: Array<Spec>;
  showDifferences: boolean;
  shouldShowFiller: boolean;
}

export const ProductCompareTableSubSection = ({
  specs,
  showDifferences,
  shouldShowFiller,
}: ProductCompareTableSubSectionProps) => {
  return (
    <>
      {specs.map((spec: Spec) => {
        const isDimension = spec.name === 'dimensionsImages';

        return (
          <tr className={styles.resultRow} key={spec.name}>
            <th className={styles.firstColumn}>{isDimension ? '' : spec.name}</th>
            {spec.values.map((specValue, i) => (
              <td className={styles.specCell} key={i}>
                {isDimension && spec.values[i] ? (
                  <div className={styles.dimensionsImageWrapper}>
                    <img
                      alt="Describes the product's dimensions"
                      className={styles.dimensionsImage}
                      src={spec.values[i].toString()}
                    />
                  </div>
                ) : (
                  <span className={showDifferences && spec.hasDifferences ? styles.specValue : ''}>
                    {getCellDisplayValue(String(specValue))}{' '}
                  </span>
                )}
              </td>
            ))}
            {shouldShowFiller ? <td></td> : null}
          </tr>
        );
      })}
    </>
  );
};
